import {
  getSectionScrollVisualFrameElement,
  scrollToSectionStart,
} from './scrollToSectionStart';

/** Homepage section ids that footer / deep links may target. */
export const HOME_HASH_SECTION_IDS = new Set([
  'workflow',
  'workspaces',
  'platforms',
  'pipeline',
  'review',
  'revisions',
  'team',
  'get-started',
]);

function isHomeSectionReadyForScroll(sectionId) {
  const sectionElement = document.getElementById(sectionId);
  if (!sectionElement) return false;

  const isMobileViewport = window.matchMedia('(max-width: 48rem)').matches;
  if (isMobileViewport) return true;

  return Boolean(getSectionScrollVisualFrameElement(sectionElement));
}

export function scrollToHomeSection(sectionId, { behavior = 'auto' } = {}) {
  const normalizedId = String(sectionId || '').replace(/^#/, '').trim();
  if (!normalizedId || !HOME_HASH_SECTION_IDS.has(normalizedId)) return;
  scrollToSectionStart(normalizedId, { behavior });
}

/** After route paint, jump to a homepage section (mobile + desktop). */
export function scheduleScrollToHomeSection(sectionId, { behavior = 'auto' } = {}) {
  if (typeof window === 'undefined') return;

  const normalizedId = String(sectionId || '').replace(/^#/, '').trim();
  if (!normalizedId || !HOME_HASH_SECTION_IDS.has(normalizedId)) return;

  let attempts = 0;
  const maxAttempts = 16;

  const attempt = () => {
    if (!isHomeSectionReadyForScroll(normalizedId) && attempts < maxAttempts) {
      attempts += 1;
      requestAnimationFrame(attempt);
      return;
    }

    scrollToHomeSection(normalizedId, { behavior });
  };

  requestAnimationFrame(attempt);
}
